import { Response } from '@angular/http'

import { ApiError, HttpStatus } from '../'
import { Utils } from '../../helpers'
import * as Errors from './'

export class ApiErrorFactory {

  public constructor(
    private _utils: Utils,
    private _httpStatus: HttpStatus
  ) {}

  public get(requestMethod: string, endpointPointer: string, requestBody: string,
             response: Response, parsedResult: any = {}): ApiError {
    const errorClass = this.getErrorClass(response)
    const errorDataJson = this.collectApiRequestErrorData(
      requestMethod, endpointPointer, requestBody,
      response, parsedResult
    )
    return this.populateErrorData(new errorClass(), errorDataJson)
  }

  private getErrorClass(response): any {
    let ErrorClass
    switch (response.status) {
      case 401:
        ErrorClass = Errors.AuthenticationError
        break
      default:
        ErrorClass = Errors.ApiError
    }
    return ErrorClass
  }

  private collectApiRequestErrorData(requestMethod: string, endpointPointer: string, requestBody: string,
                                     response: Response, parsedResult: any = {}): any {

    let collectedErrorData = {}

    if (this._utils.propertyNotEmpty(parsedResult, 'errors')) {
      collectedErrorData = parsedResult.errors[0]
    } else {
      collectedErrorData = {
        id: `${(+new Date()).toString()}-${response.status}`,
        status: String(response.status),
        detail: `Requesting data from '${response.url}' using ${requestMethod.toUpperCase()} method
                                        failed with HTTP status code ${response.status} (${response.statusText}).`
      }
    }

    const [pointerClean, parameterClean] = typeof endpointPointer === 'string'
      ? endpointPointer.split('?') : ['unknown', undefined]

    collectedErrorData['source'] = Object.assign({}, {
        pointer: pointerClean || '',
        parameter: parameterClean || '',
        payload: requestBody || ''
      }, collectedErrorData['source'])

    collectedErrorData['meta'] = Object.assign({}, {
        headers: response.headers.toJSON(),
        statusText: response.statusText,
        url: response.url,
        method: requestMethod.toUpperCase()
      }, collectedErrorData['meta'])

    return collectedErrorData
  }

  private populateErrorData(error: ApiError, errorDataJson: any): ApiError {
    const acceptedPropertyNames = ['id', 'links', 'status', 'code', 'title', 'detail', 'source', 'meta']
    acceptedPropertyNames.forEach((propertyName) => {
      if (errorDataJson.hasOwnProperty(propertyName) && typeof errorDataJson[propertyName] !== 'function') {
        error[propertyName] = errorDataJson[propertyName]
      }
    })
    if (!errorDataJson.hasOwnProperty('title') && typeof errorDataJson.hasOwnProperty('status')) {
      const statusCode = +errorDataJson.status
      const statusCategory = this._httpStatus.getCategory(statusCode)
      const httpStatusMessage = this._httpStatus.getMessage(statusCode)
      error['title'] = `HTTP ${statusCategory}: ${httpStatusMessage} (${statusCode})`
    }
    return error
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/errors/api-error.factory.ts